import { CommonMessage } from '@frontend/lang';
import React from 'react';
import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

const SEARCH_KEY_DISPLAY_NAMES = new Map<string, ReactNode>([
    [
        'All',
        <FormattedMessage
            id='feature.transactions.tabs.all'
            defaultMessage='All'
        />
    ],
    ['tracking_number', CommonMessage.OBJECTS.TRANSACTION.TRACKING_NUMBER],
    ['sender', CommonMessage.OBJECTS.TRANSACTION.SENDER],
    ['senders', CommonMessage.OBJECTS.TRANSACTION.SENDERS],
    ['receiver', CommonMessage.OBJECTS.TRANSACTION.RECEIVER],
    ['receivers', CommonMessage.OBJECTS.TRANSACTION.RECEIVERS],
    ['shipping_notes', CommonMessage.OBJECTS.TRANSACTION.SHIPPING_NOTES],
    ['purchase_order', CommonMessage.OBJECTS.TRANSACTION.PURCHASE_ORDER],
    ['name', CommonMessage.OBJECTS.COMMON_FIELDS.NAME],
    ['status', CommonMessage.OBJECTS.COMMON_FIELDS.STATUS],
    ['product', CommonMessage.OBJECTS.PRODUCT.DEFAULT],
    ['equipment', CommonMessage.OBJECTS.EQUIPMENT.DEFAULT],
    ['user', CommonMessage.OBJECTS.USER.DEFAULT],
    ['cost_center', CommonMessage.OBJECTS.COST_CENTER.DEFAULT],
    ['spot', CommonMessage.OBJECTS.SPOT.DEFAULT],
    ['slot', CommonMessage.OBJECTS.SLOT.DEFAULT],
    ['tag', CommonMessage.OBJECTS.TAG.DEFAULT],
    ['serial_number', CommonMessage.OBJECTS.EQUIPMENT.SERIAL_NUMBER],
    ['owner', CommonMessage.OBJECTS.PRODUCT.OWNER],
    ['categories', CommonMessage.OBJECTS.CATEGORY.PLURAL],
    ['category', CommonMessage.OBJECTS.CATEGORY.DEFAULT],
    ['first_name', CommonMessage.OBJECTS.USER.FIRST_NAME],
    ['last_name', CommonMessage.OBJECTS.USER.LAST_NAME],
    ['email', CommonMessage.OBJECTS.USER.EMAIL],
    ['mobile', CommonMessage.OBJECTS.USER.MOBILE],
    ['unique_identifier', CommonMessage.FORMS.UNIQUE_IDENTIFIER],
    ['department', CommonMessage.OBJECTS.USER.DEPARTMENT],
    ['ean', CommonMessage.OBJECTS.PRODUCT.EAN],
    ['sku', CommonMessage.OBJECTS.PRODUCT.SKU],
    ['label', CommonMessage.OBJECTS.PARCEL.DEFAULT],
    ['code', CommonMessage.FORMS.CODE],
    ['number', CommonMessage.OBJECTS.ORDER.ORDER_NUMBER],
    ['display', CommonMessage.FORMS.DISPLAY],
    ['module', CommonMessage.OBJECTS.MODULE.DEFAULT],
    ['product_category', CommonMessage.OBJECTS.PRODUCT_CATEGORY.DEFAULT],
    ['equipment_tag', CommonMessage.OBJECTS.EQUIPMENT.TAG],
    ['certificate', CommonMessage.OBJECTS.CERTIFICATE.CERTIFICATE_NAME],
    ['search', CommonMessage.OBJECTS.CATEGORY.CATEGORY_NAME],
    [
        'subject',
        <FormattedMessage
            id='content-detail.subject'
            description='Label for a notification content subject'
            defaultMessage='Subject'
        />
    ],
    [
        'channel',
        <FormattedMessage
            id='content-detail.channel'
            description='Label for a notification content channel'
            defaultMessage='Channel'
        />
    ]
]);

export function resolveSearchKeyDisplayName(key: string, overrides?: Map<string, ReactNode>): ReactNode | undefined {
    return overrides?.get(key) ?? SEARCH_KEY_DISPLAY_NAMES.get(key);
}
